<template lang="pug">
code.mt-2(v-if='isDebugMode && value') {{ JSON.stringify(value, 0, beautify ? 2 : 0) }}
</template>

<script>
export default {
  name: 'DebugCodeBlock',
  props: {
    value: {
      default: null,
    },
    beautify: {
      default: true,
      type: Boolean,
    },
  },
}
</script>

<style scoped lang="sass">

</style>
